// Single source of truth for the active app module.
// Driven at build time by VITE_REACT_APP_MODULE.

export const APP_MODULES = {
  INDUSTRIAL: 'INDUSTRIAL',
  MONITORING: 'MONITORING',
  MANAGER: 'MANAGER',
  ANALYSIS: 'ANALYSIS',
  ADMIN: 'ADMIN',
};

export const APP_MODULE =
  (import.meta.env.VITE_REACT_APP_MODULE || '').toUpperCase() ||
  APP_MODULES.MONITORING;

export const isMonitoring = APP_MODULE === APP_MODULES.MONITORING;
export const isIndustrial = APP_MODULE === APP_MODULES.INDUSTRIAL;
export const isManager = APP_MODULE === APP_MODULES.MANAGER;
export const isAnalysis = APP_MODULE === APP_MODULES.ANALYSIS;
export const isAdmin = APP_MODULE === APP_MODULES.ADMIN;
